import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Button, Checkbox, Modal, notification } from 'tea-component';
import './index.scss';
import { relateGamesAndGroups } from '@/pages/intelligence/services/following';
import { getFollowing, setFollowing } from '@/pages/intelligence/services/topcharts';
import { useSelector, useIntl } from 'umi';
import TextBubbles from '@/pages/home/components/TextBubbles';
import { FOLLOWING_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/Following';

const AddGroup = (props: any) => {
  let { visible, close, getCreateGroup, entityType, gameId, setFavarite, setAddGroup,
    groupOptions = [],
    addNewGroupName = '',
    gameIds,
    isMoveadd = false,
    DEFAULT_GROUPNAME,
    isFollowingUserGuideMode = false,
    setUpdateGroupList,
    getPageDatas,
    isFromAllGames = false,
    favarite = false,
  } = props;
  const { formatMessage } = useIntl(); // 中英切换方法
  const { userInfo } = useSelector((state: any) => {
    const { userInfo } = state.home;
    return { userInfo };
  });
  const userId = userInfo?.userid ?? '';
  const [taste, setTaste] = useState<any>([]);

  useEffect(() => {
    setTaste([DEFAULT_GROUPNAME]);
    const nameList = groupOptions?.map((item: any) => item.value) || [];
    if (addNewGroupName != '' && nameList?.includes(addNewGroupName)) {
      setTaste([...taste, addNewGroupName]);
    }
  }, [groupOptions]);

  const handleFeedback = (isSuccess: boolean) => {
    const notificationConfig = {
      successMsg: (
        <>{
          isFromAllGames ?
            <span>{formatMessage({ id: 'dbi_successfully_added' })} </span>
            :
            <span>
              {formatMessage({ id: 'dbi_followed_successfully' }) + ' '}
              <a
                href="javascript: void(0)"
                style={{ margin: '0 26px 0 8px', color: '#0076FF' }}
                onClick={() => {
                  setAddGroup && setAddGroup(true);
                }}
              >
                {formatMessage({ id: 'dbi_add_to_group' })}
              </a>
            </span>
        }
        </>
      ),
      failedMsg: formatMessage({ id: 'dbi_followed_failed_again' }),
    };
    if (isSuccess) {
      notification.success({
        unique: true,
        description: notificationConfig.successMsg,
      });
    } else {
      notification.error({
        unique: true,
        description: notificationConfig.failedMsg,
      });
    }
  };

  const handleClose = () => {
    setTaste([]);
    close && close();
  }

  const handleSubmitGameDetail = async () => {
    handleClose();
    const arrList = taste.filter((item: any) => item != DEFAULT_GROUPNAME);
    //如果是manager页面添加进分组，多个游戏
    if (isMoveadd || favarite) {
      const _apiData = {
        entity_type: entityType,
        move_type: "moveadd", // 只有moveto和moveout
        from_entity_names: '',  //要移出的分组名称
        to_entity_names: arrList,  // 要移入的分组名称，如果只是移出moveout，则这个字段可以没有，
        game_id: favarite ? [gameId] : (gameIds || []), //要移出的游戏id
      }
      let isSuccess = false;
      try {
        const res = await relateGamesAndGroups(_apiData)
        if (res?.code === 0 || res?.code === 200) {
          isSuccess = true;
          setUpdateGroupList?.(true);
          getPageDatas?.();
        } else {
          isSuccess = false;
        }
      } catch (err) {
        isSuccess = false;
      } finally {
        handleFeedback(isSuccess);
      }
    } else {
      const params = {
        user_id: userId,
        game_company_id: gameId || '',
        entity_type: entityType,
        is_collection: true,
        group_name: arrList,
      };
      let isSuccess = false;
      try {
        const res = setFollowing(params);
        isSuccess = true;
        setFavarite(true);
      } catch (exception) {
        setFavarite(false);
        console.warn(exception);
        isSuccess = false;
      } finally {
        handleFeedback(isSuccess);
      }
    }
  };

  return (
    <Modal
      className={classnames('dbi-add-group', FOLLOWING_GUIDE_CLASSNAMES.ELEMENT1)}
      maskStyle={isFollowingUserGuideMode ? { background: 'transparent' } : {}}
      visible={visible}
      size={500}
      caption={formatMessage({ id: 'dbi_add_to_group' })}
      onClose={() => handleClose()}
    >
      <Modal.Body>
        <Checkbox.Group
          className="dbi-add-group-checkbox"
          value={taste}
          onChange={(value) => setTaste(value)}
        >
          <Checkbox className="dbi-add-group-item" name={DEFAULT_GROUPNAME} disabled={true} key={DEFAULT_GROUPNAME}>
            {DEFAULT_GROUPNAME}
          </Checkbox>
          {
            groupOptions.map((item: any, index: any) => {
              return <Checkbox className="dbi-add-group-item" name={item.value} key={index}>
                <TextBubbles text={item.text} />
              </Checkbox>
            })
          }
        </Checkbox.Group>
        <a className='dbi-add-group-btn' onClick={() => getCreateGroup()}>{formatMessage({ id: 'dbi_create_new_group' })}</a>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            handleSubmitGameDetail()
          }}
        >
          {formatMessage({ id: 'dbi_confirm' })}
        </Button>
        <Button
          type="weak"
          onClick={() => {
            handleClose();
          }}
        >
          {formatMessage({ id: 'dbi_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddGroup;
